import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmployeeService } from 'app/modules/employee/services/employee.service';

@Component({
    selector: 'app-add-edit-warning-popup',
    templateUrl: './add-edit-warning-popup.component.html',
    styleUrls: ['./add-edit-warning-popup.component.scss'],
    standalone: false
})
export class AddEditWarningPopupComponent implements OnInit {

  public EmployeeWarningForm: UntypedFormGroup;
  public EmployeeId: number;

  constructor(
    public dialogRef: MatDialogRef<AddEditWarningPopupComponent>,
    private formBuilder: UntypedFormBuilder,
    private employeeService: EmployeeService,
    private sharedService: SharedService) { }

  ngOnInit(): void {
    this.InitForm();
    this.SetFormValues();
  }

  private InitForm(): void {
    this.EmployeeWarningForm = this.formBuilder.group({
      EmployeeId: [null, Validators.required],
      WarningText: [null, Validators.required]
    });
  }

  private SetFormValues(): void {
    this.EmployeeWarningForm.patchValue({
      EmployeeId: this.EmployeeId,
      WarningText: this.employeeService.EmployeeWarningText
    });
  }

  public Close(): void {
    this.dialogRef.close();
  }

  public SaveWarningText(): void {
    if (this.EmployeeWarningForm.valid) {
      this.employeeService.SaveWarningText(String(this.EmployeeId), this.EmployeeWarningForm.value).subscribe(res => {
        if (res.code === 0) {
          this.sharedService.ShowSnackBar('Guardado correctamente el aviso');
          this.employeeService.saveemplooye.emit(this.EmployeeId);
          this.Close();
        } else {
          this.sharedService.ShowSnackBar('No se pudo guardar el aviso');
        }
      }, error => {
        this.sharedService.ShowSnackBar('No se pudo guardar el aviso');
        console.error(error);
      });
    }
  }

}
